import { ReactElement } from 'react';

import { Dropdown, usePush } from '@dreryk/react-components';

import { getHealthcareProviderDataPath } from '../routes';
import { healthcareOrganizationTranslationKeys } from '../translations';

export const MyOrganizationDropdownItem = (): ReactElement => {
   const push = usePush();

   return (
      <Dropdown.Item
         testId={'myOrganization'}
         onClick={(hide) => {
            push(getHealthcareProviderDataPath('HEALTHCARE_ORGANIZATION'));
            hide();
         }}
      >
         {healthcareOrganizationTranslationKeys.myOrganization}
      </Dropdown.Item>
   );
};
